export default function ProcessHero() {
  return (
    <section className="w-full bg-white pt-24 pb-0 border-b border-gray-100">
      <div className="max-w-5xl mx-auto px-6">
        <div className="py-10 flex flex-col md:flex-row md:items-center gap-6">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-4">
              <span
                className="text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full"
                style={{ backgroundColor: 'rgba(46,125,107,0.1)', color: '#2E7D6B' }}
              >
                SERVICE GUIDE
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 leading-snug mb-3">
              서비스 <span style={{ color: '#2E7D6B' }}>이용안내</span>
            </h1>
            <div
              className="rounded-xl px-5 py-4 text-sm leading-relaxed"
              style={{ backgroundColor: '#f0f9f6', borderLeft: '4px solid #2E7D6B' }}
            >
              <p className="text-gray-700">
                코리아케어러스는 환자와 간병인을 연결하는 매칭 플랫폼입니다. 아래 3단계로 서비스를 이용해보세요.
              </p>
              <p className="text-xs text-gray-500 mt-1">
                회원가입부터 매칭 완료까지, 간편하게 진행됩니다.
              </p>
            </div>
          </div>
          <div className="flex-shrink-0 flex items-center justify-center">
            <div
              className="w-32 h-32 md:w-40 md:h-40 rounded-2xl flex flex-col items-center justify-center gap-2"
              style={{ backgroundColor: '#f0f9f6', border: '2px solid rgba(46,125,107,0.2)' }}
            >
              <i className="ri-guide-line text-4xl md:text-5xl" style={{ color: '#2E7D6B' }}></i>
              <span className="text-xs font-bold text-gray-600">이용 3단계</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}